import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterArrayPredicate'
})
export class FilterArrayPredicatePipe implements PipeTransform {
  transform(value: any[], predicate?: (e: any) => boolean) {
    return predicate == null || value == null ? value : value.filter(predicate);
  }
}
